/** Light archive personalisation — local only, brand-controlled presets. */

const ACCENT_KEY = 'gb_archive_accent';
const TONE_KEY = 'gb_archive_tone';

/** Curated accent themes — accents/highlights only, not full palette overrides. */
export const ACCENT_PRESETS = [
  { id: 'heritage', label: 'Heritage Green', css: { '--studio-accent': '152 28% 32%' } },
  { id: 'warm-gold', label: 'Warm Gold', css: { '--studio-accent': '38 42% 44%' } },
  { id: 'deep-navy', label: 'Deep Navy', css: { '--studio-accent': '220 32% 28%' } },
  { id: 'soft-plum', label: 'Soft Plum', css: { '--studio-accent': '290 22% 38%' } },
  { id: 'rosewood', label: 'Rosewood', css: { '--studio-accent': '12 28% 36%' } },
];

/** Legacy ids map to nearest curated preset. */
const LEGACY_ACCENT_MAP = {
  sage: 'heritage',
  warm: 'warm-gold',
};

export const TONE_PRESETS = [
  { id: 'warm', label: 'Warm & conversational', hint: 'Gentle, family-first wording' },
  { id: 'formal', label: 'Formal archive', hint: 'Measured, documentary tone' },
];

export function getStoredAccent() {
  try {
    const raw = localStorage.getItem(ACCENT_KEY) || 'heritage';
    return LEGACY_ACCENT_MAP[raw] || raw;
  } catch {
    return 'heritage';
  }
}

export function getStoredTone() {
  try {
    return localStorage.getItem(TONE_KEY) || 'warm';
  } catch {
    return 'warm';
  }
}

export function applyAccentPreset(presetId) {
  const resolved = LEGACY_ACCENT_MAP[presetId] || presetId;
  const preset = ACCENT_PRESETS.find((p) => p.id === resolved) || ACCENT_PRESETS[0];
  try {
    localStorage.setItem(ACCENT_KEY, preset.id);
  } catch {
    /* ignore */
  }
  Object.entries(preset.css).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
}

export function initArchivePersonalization() {
  applyAccentPreset(getStoredAccent());
}

export function setArchiveTone(toneId) {
  try {
    localStorage.setItem(TONE_KEY, toneId);
  } catch {
    /* ignore */
  }
}
